// extracted by mini-css-extract-plugin
module.exports = {"container":"PropertyListGroup_container__1Ojmz","editIcon":"PropertyListGroup_editIcon__L-w_t"};